import { useState } from "react";
import styled from "styled-components";
import { KTIcon } from "../../../../_metronic/helpers";

const readDismissed = storageKey => {
  try {
    return window.sessionStorage.getItem(storageKey) === "1";
  } catch {
    return false;
  }
};

/**
 * Session-scoped dismissal. `storageKey` should include the banner's content so
 * a new condition (different message/stores) shows the banner again.
 */
export const useBannerDismiss = storageKey => {
  const [dismissedKey, setDismissedKey] = useState(null);
  const dismissed = dismissedKey === storageKey || readDismissed(storageKey);

  const dismiss = () => {
    try {
      window.sessionStorage.setItem(storageKey, "1");
    } catch {
      // Storage unavailable: dismissal still applies until reload.
    }
    setDismissedKey(storageKey);
  };

  return [dismissed, dismiss];
};

const CloseButton = styled.button`
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: #262641;
  cursor: pointer;

  &:hover {
    background: rgba(38, 38, 65, 0.08);
  }
`;

export const BannerCloseButton = ({ onClick }) => (
  <CloseButton type="button" onClick={onClick} aria-label="Dismiss">
    <KTIcon className="fs-2" iconName="cross" />
  </CloseButton>
);
